import { useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger, DialogFooter, DialogDescription,
} from "@/components/ui/dialog";
import { KeyRound, Loader2, CheckCircle2 } from "lucide-react";

export default function PortalAccessDialog({ patient }) {
  const [open, setOpen] = useState(false);
  const [email, setEmail] = useState(patient.portal_email || "");
  const [password, setPassword] = useState("");
  const [saving, setSaving] = useState(false);
  const linked = !!patient.linked_user_id;

  const save = async () => {
    if (!email || !password) { toast.error("Informe e-mail e senha"); return; }
    setSaving(true);
    try {
      await api.post(`/patients/${patient.id}/portal-access`, { email, password });
      toast.success("Acesso do paciente criado");
      setOpen(false);
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="outline" data-testid="portal-access-btn">
          {linked ? <CheckCircle2 className="w-4 h-4 mr-2 text-success" /> : <KeyRound className="w-4 h-4 mr-2" />}
          {linked ? "Portal ativo" : "Dar acesso ao portal"}
        </Button>
      </DialogTrigger>
      <DialogContent data-testid="portal-access-dialog">
        <DialogHeader>
          <DialogTitle>Acesso do paciente ao portal</DialogTitle>
          <DialogDescription>
            {linked
              ? `Este paciente já tem acesso (${patient.portal_email}).`
              : "Crie um login para o paciente acompanhar resultados, tarefas e conectar dispositivos."}
          </DialogDescription>
        </DialogHeader>
        {!linked && (
          <div className="space-y-4 py-2">
            <div className="space-y-2"><Label>E-mail do paciente</Label>
              <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="portal-email-input" /></div>
            <div className="space-y-2"><Label>Senha provisória</Label>
              <Input value={password} onChange={(e) => setPassword(e.target.value)} data-testid="portal-password-input" /></div>
          </div>
        )}
        {!linked && (
          <DialogFooter>
            <Button onClick={save} disabled={saving} data-testid="save-portal-access-btn">
              {saving && <Loader2 className="w-4 h-4 mr-2 animate-spin" />} Criar acesso
            </Button>
          </DialogFooter>
        )}
      </DialogContent>
    </Dialog>
  );
}
